/* 
--- DEVELOPER WARNING ---
This is a generated file.
Any changes you make to this file will not be saved nor git tracked. 
*/

import appinventorprg95grpexample_IconURL from '../RAISE_Logo.png';
import appinventorprg95grpexample_InsetIconURL from '../PRG_Logo.png';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export default {
	name: 
  (
    <FormattedMessage
        defaultMessage="App Inventor Example"
        description="name for the App Inventor Example extension"
        id="extension.appinventorprg95grpexample.name"
    />
  ),
	tags: ["PRG Internal"],
	featured: true,
	extensionId: 'appinventorprg95grpexample',
	iconURL: appinventorprg95grpexample_IconURL,
	insetIconURL: appinventorprg95grpexample_InsetIconURL,
}